module.exports = __webpack_public_path__ + "static/img/weixin.107b14b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contactus/weixin.png
// module id = WvNm
// module chunks = 51